<script>
import Layout from '../../layout/Layout'
import MenuOptions from '../../layout/context-menu/context-window-options'
import DefaultMixin from '../mixin'

export default {
  name: 'ParceirosPage',
  mixins: [DefaultMixin],
  components: {
    Layout
  },
  data () {
    return {
    }
  },
  computed: {
    menuDashOptions () {
      return MenuOptions
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
  },
  meta: {
    title: 'Parceiros',
    name: 'Parceiros'
  }
}
</script>

<template>
  <layout no-menu menu-style="compact" menu-active="tasks" menu-name="VIS" no-title hfull>
    <router-view />
  </layout>
</template>

<style lang="stylus" src="../assets/default.styl"></style>
